export default __webpack_public_path__ + "static/media/copy-icon.68868aa1.svg";